import { Text } from 'react-native-paper';
import useFormStyle from '@/components/Styles/useFormStyle';
import { Redirect, useGlobalSearchParams, useRouter } from 'expo-router';
import ScreenMargin from '@/components/ScreenMargin';
import { useForm } from 'react-hook-form';
import {
  UpdateLaboratoireMutationVariables,
  useGetLaboratoireQuery,
  useUpdateLaboratoireMutation,
} from '@/data/data';
import { useUserContext } from '@/components/Auth/UserContext';
import { useState } from 'react';
import Form from '@/components/Form/Form';
import { View } from 'react-native';
import FTextInput from '@/components/Form/TextInput';
import BaseContainer from '@/components/BaseContainer';
import { AvailableValidationRules } from '@/components/Form/validation';
import FormSectionFooter from '@/components/Form/FormSectionFooter';
import { useApolloClient } from '@apollo/client';
import { getAdminLink, getNormalLink } from '@/components/Apollo/client';
import { useAuthContext } from '@/components/Auth/AuthContext';
import { useTranslation } from 'react-i18next';

const MajLaboratoirePage = () => {
  const client = useApolloClient();
  const { detail } = useGlobalSearchParams();
  const authUser = useAuthContext();

  const { data: laboratoire } = useGetLaboratoireQuery({
    variables: {
      id: detail,
    },
    fetchPolicy: 'network-only',
  });

  const { user } = useUserContext();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [updateLaboratoire] = useUpdateLaboratoireMutation();
  const form = useForm<UpdateLaboratoireMutationVariables['data']>();

  const styles = useFormStyle();

  if (authUser.payload && authUser.payload['cognito:groups'].indexOf('admin') <= -1) {
    return <Redirect href={'/patients'} />;
  }

  return (
    <ScreenMargin>
      <BaseContainer withScrollView={'keyboardAware'}>
        <Text style={styles?.headerForm}>{t('Mettre à jour un laboratoire')}</Text>

        <Form<UpdateLaboratoireMutationVariables['data']>
          {...form}
          defaultValues={laboratoire?.laboratoireByPk}
        >
          <View style={styles?.bodyForm}>
            <View style={styles?.groupForm}>
              <Text style={styles?.titleGroupForm}>{t('Données')}</Text>
              <FTextInput
                name={'nom'}
                label={'Nom'}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
            </View>
          </View>
          <View style={styles?.footerForm}>
            <FormSectionFooter
              saveLoading={loading}
              saveDisabled={loading}
              onPress={form.handleSubmit(async (data) => {
                setLoading(true);
                if (user) {
                  client.setLink(getAdminLink());
                  await updateLaboratoire({
                    variables: {
                      data,
                      id: detail,
                    },
                    fetchPolicy: 'network-only',
                  });
                  client.setLink(getNormalLink());
                }
                setLoading(false);
                router.back();
              })}
            />
          </View>
        </Form>
      </BaseContainer>
    </ScreenMargin>
  );
};

export default MajLaboratoirePage;
